<template>
  <div class="report-tabs-bar">
    <div class="report-tabs">

      <router-link
        :to="$url('/balance-sheet-report')"
        class="report-tab"
        :class="isActive(['Balance Sheet Report']) ? 'report-tab--active' : ''"
      >
        <font-awesome-icon icon="balance-scale" class="tab-icon" />
        Balance Sheet
      </router-link>

      <router-link
        :to="$url('/trial-balance-report')"
        class="report-tab"
        :class="isActive(['Trial Balance Report']) ? 'report-tab--active' : ''"
      >
        <font-awesome-icon icon="calculator" class="tab-icon" />
        Trial Balance
      </router-link>

      <router-link
        :to="$url('/income-statement-report')"
        class="report-tab"
        :class="isActive(['Income Statement Report']) ? 'report-tab--active' : ''"
      >
        <font-awesome-icon icon="chart-line" class="tab-icon" />
        Income Statement
      </router-link>

      <!-- Locked if freemium -->
      <span
        v-if="freemium"
        class="report-tab report-tab--locked"
        @click="freemiumPrompt"
        title="Upgrade to access Chart of Account"
      >
        <font-awesome-icon icon="sitemap" class="tab-icon" />
        Chart of Account
        <span class="lock-badge">
          <font-awesome-icon icon="lock" />
        </span>
      </span>
      <router-link
        v-else
        :to="$url('/chart-of-account')"
        class="report-tab"
        :class="isActive(['Chart of Account']) ? 'report-tab--active' : ''"
      >
        <font-awesome-icon icon="sitemap" class="tab-icon" />
        Chart of Account
      </router-link>

      <router-link
        :to="$url('/cash-flow-statement')"
        class="report-tab"
        :class="isActive(['Cash Flow Statement']) ? 'report-tab--active' : ''"
      >
        <font-awesome-icon icon="water" class="tab-icon" />
        Cash Flow
      </router-link>

    </div>
  </div>
</template>

<script>
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';
import axios from 'axios';

export default {
  name: 'ReportHeaderTab',

  setup() {
    const router   = useRouter();
    const isActive = (names) => names.includes(router.currentRoute.value.name);
    return { isActive };
  },

  data() {
    return {
      freemium: true,
      toast: useToast(),
    };
  },

  mounted() { this.activeSubscription(); },

  methods: {
    activeSubscription() {
      axios.get('/subscription/user')
        .then(response => {
          const active = response.data.data.filter(d => d.status == 1 || d.status == 0);
          this.freemium = active.length === 0;
        })
        .catch(() => {});
    },

    freemiumPrompt() {
      this.toast.error('Subscribe or upgrade to access this feature');
    },
  },
};
</script>

<style scoped>
/* ── Bar ── */
.report-tabs-bar {
  background: #fff;
  border-bottom: 1px solid #e4eaf2;
  padding: 0 20px;
  margin-bottom: 20px;
}

/* ── Tab Row ── */
.report-tabs {
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}
.report-tabs::-webkit-scrollbar { display: none; }

/* ── Individual Tab ── */
.report-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 13px 16px;
  font-size: 13.5px;
  font-weight: 500;
  color: #7a90b0;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  margin-bottom: -1px;
  cursor: pointer;
  user-select: none;
}
.report-tab:hover:not(.report-tab--locked) {
  color: #004AAD;
  text-decoration: none;
}

/* ── Active ── */
.report-tab--active {
  color: #004AAD !important;
  border-bottom-color: #004AAD !important;
  font-weight: 600;
}

/* ── Locked (freemium) ── */
.report-tab--locked {
  color: #aab8cc;
  cursor: pointer;
  position: relative;
}
.report-tab--locked:hover { color: #7a90b0; }

.lock-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff7ed;
  color: #e08c00;
  border: 1px solid #fed7aa;
  border-radius: 20px;
  padding: 1px 7px;
  font-size: 10px;
  margin-left: 2px;
}

/* ── Icon ── */
.tab-icon { font-size: 13px; opacity: 0.85; }

/* ── Responsive ── */
@media (max-width: 576px) {
  .report-tabs-bar { padding: 0 12px; }
  .report-tab      { padding: 11px 12px; font-size: 13px; gap: 5px; }
}
</style>